import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { ProbateType } from "../../../models/ProbateType";
import { ProbateFolder } from "./ProbateFolder";

interface Props {
  probate: ProbateType;
  state?: string;
}

export const ProbatePacketCard = ({ probate, state }: Props): JSX.Element => {
  return probate?.id ? (
    <Card
      sx={{
        my: 4,
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        <ProbateFolder probateTierName={probate.probateAtticusTier?.name} />
        <Box>
          <Typography variant="h5" sx={{ mx: 2 }}>
            {probate.name} Packet {state && ` for ${state}`}
          </Typography>
          {probate.explanation && (
            <Typography sx={{ mx: 2, my: 1 }}>{probate.explanation}</Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  ) : (
    <></>
  );
};
